import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { ViewByType } from 'container/ManageOrders'

type InitialState = {
  viewByFilter: ViewByType
  orderStep: 0 | 1
  isDirty: boolean
  showPrompt: boolean
  confirmedNavigation: boolean
  globalLoading: boolean
  tabBlockers: string[]
  focusMaterialInsertInput: boolean
  ovInitialTab: number
  salesOrderInitialTab: number
  salesOrderCurrentTab: number
  showDetailedStock: boolean
  loginValidation: boolean
  openRecommendationModal: boolean
}
const initialState: InitialState = {
  confirmedNavigation: false,
  focusMaterialInsertInput: false,
  globalLoading: false,
  isDirty: false,
  loginValidation: false,
  openRecommendationModal: false,
  orderStep: 0,
  ovInitialTab: 0,
  salesOrderCurrentTab: -1,
  salesOrderInitialTab: -1,
  showDetailedStock: true,
  showPrompt: false,
  tabBlockers: [],
  viewByFilter: 'orders',
}

export const structure = createSlice({
  initialState,
  name: 'structure',
  reducers: {
    addTabBlocker(state, action: PayloadAction<string>) {
      if (!state.tabBlockers.includes(action.payload)) {
        state.tabBlockers.push(action.payload)
      }
    },
    clearTabBlockers(state) {
      state.tabBlockers = []
    },
    removeTabBlocker(state, action: PayloadAction<string>) {
      state.tabBlockers = state.tabBlockers.filter((blocker) => blocker !== action.payload)
    },
    setConfirmedNavigation: (state, action: PayloadAction<boolean>) => {
      state.confirmedNavigation = action.payload
    },
    setDirty: (state, action: PayloadAction<boolean>) => {
      state.isDirty = action.payload
    },
    setFocusMaterialInsertInput(state, action: PayloadAction<boolean>) {
      state.focusMaterialInsertInput = action.payload
    },
    setGlobalLoading(state, action: PayloadAction<boolean>) {
      state.globalLoading = action.payload
    },
    setLoginValidation(state, action: PayloadAction<boolean>) {
      state.loginValidation = action.payload
    },
    setOpenRecommendationModal(state, action: PayloadAction<boolean>) {
      state.openRecommendationModal = action.payload
    },
    setOvInitialTab(state, action: PayloadAction<number>) {
      state.ovInitialTab = action.payload
    },
    setSalesOrderCurrentTab(state, action: PayloadAction<number>) {
      state.salesOrderCurrentTab = action.payload
    },
    setSalesOrderInitialTab(state, action: PayloadAction<number>) {
      state.salesOrderInitialTab = action.payload
    },
    setShowDetailedStock(state, action: PayloadAction<boolean>) {
      state.showDetailedStock = action.payload
    },
    setShowPrompt: (state, action: PayloadAction<boolean>) => {
      state.showPrompt = action.payload
    },
    setViewByFilter: (state, action: PayloadAction<ViewByType>) => {
      state.viewByFilter = action.payload
    },
    updateOrderStep(state, action: PayloadAction<0 | 1>) {
      state.orderStep = action.payload
    },
  },
})
export const structuralContext = structure.reducer
export const {
  setViewByFilter,
  updateOrderStep,
  setDirty,
  setConfirmedNavigation,
  setShowPrompt,
  setGlobalLoading,
  addTabBlocker,
  removeTabBlocker,
  clearTabBlockers,
  setFocusMaterialInsertInput,
  setOvInitialTab,
  setSalesOrderInitialTab,
  setSalesOrderCurrentTab,
  setShowDetailedStock,
  setLoginValidation,
  setOpenRecommendationModal,
} = structure.actions
